@if (!isEntityListLoading()) {
  <div class="w-100">
    <gstar-combobox
      [required]="required"
      [label]="'upsertSecurity.entity' | translate"
      [options]="entities()"
      keyProp="name"
      valueProp="entityId"
      trackByKey="entityId"
      [value]="value"
      [disabled]="disabled"
      (selectItem)="selectEntityHandler($event)"
      (clearValue)="clearEntityHandler()" />
  </div>
}
